module.exports = __webpack_public_path__ + "static/joc_08-c4b6af42e172ece01e386dec9c43f42d.jpg";